import { jsxs as c, jsx as l } from "react/jsx-runtime";
import { E as d, S as u } from "./icons.types-0722eef5.js";
function g({ title: r, titleId: t, size: e, width: n, height: s, extended: o = !1, ...v }) {
  const i = o ? d : u, a = e ? i[e] : n || i[o ? "s" : "l"], h = e ? i[e] : s || i[o ? "s" : "l"];
  return /* @__PURE__ */ c(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 72 72",
      width: a,
      height: h,
      "aria-labelledby": t,
      ...v,
      children: [
        r ? /* @__PURE__ */ l("title", { id: t, children: r }) : null,
        /* @__PURE__ */ l("g", { clipPath: "url(#Remove_Favourite_svg__a)", children: /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "m32.166 6 7.666 15.58v7.3l-.734-.108-6.932-14.085-6.933 14.085L9.734 31.03l10.932 10.403-2.573 16.037 14.073-7.307 14.073 7.307-2.574-16.037 8.225-7.697h5.337l-9.443 9.038L51.336 64.5l-19.17-9.997-19.17 9.997 3.55-21.725L1.5 28.345l21.187-3.088L32.166 6ZM70.5 26.054V29.9H43.668v-3.847H70.5Z",
            clipRule: "evenodd"
          }
        ) }),
        /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "Remove_Favourite_svg__a", children: /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M0 0h72v72H0z"
          }
        ) }) })
      ]
    }
  );
}
export {
  g as RemoveFavourite
};
